"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transition = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var time_unit_1 = require("./time-unit");
exports.transition = type_guard_1.props({
    duration: time_unit_1.timeUnit,
    function: type_guard_1.optional(type_guard_1.union([
        type_guard_1.pattern(/(cubic-bezier\(((0|1)(\.\d+)?),\s?((0|1)(\.\d+)?),\s?((0|1)(\.\d+)?),\s?((0|1)(\.\d+)?)\))/),
        type_guard_1.literal('ease-in-out'),
        type_guard_1.literal('ease-in'),
        type_guard_1.literal('ease-out'),
        type_guard_1.literal('linear')
    ])),
    delay: type_guard_1.optional(time_unit_1.timeUnit)
});
